var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_iso") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_zip",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "iso",
    d: "M3371.8,7162H3359v-16h8.229v4.7h4.571V7162Zm-4.192-6.767a1.488,1.488,0,0,0-.794.217,1.441,1.441,0,0,0-.536.629,2.2,2.2,0,0,0-.19.947v.207a2.161,2.161,0,0,0,.192.931,1.441,1.441,0,0,0,.539.62,1.568,1.568,0,0,0,1.593,0,1.421,1.421,0,0,0,.532-.624,2.273,2.273,0,0,0,.187-.947v-.2a2.209,2.209,0,0,0-.19-.942,1.422,1.422,0,0,0-.536-.62A1.487,1.487,0,0,0,3367.608,7155.232Zm-4.706,2.612a1.014,1.014,0,0,0,.185.6,1.22,1.22,0,0,0,.52.406,1.779,1.779,0,0,0,.731.147,1.535,1.535,0,0,0,.953-.27.878.878,0,0,0,.352-.729.96.96,0,0,0-.12-.493,1.125,1.125,0,0,0-.381-.374,2.828,2.828,0,0,0-.688-.289,2.142,2.142,0,0,1-.615-.263.4.4,0,0,1-.187-.336.443.443,0,0,1,.172-.372.771.771,0,0,1,.486-.135.733.733,0,0,1,.516.164.567.567,0,0,1,.18.449h.636a1.035,1.035,0,0,0-.173-.579,1.119,1.119,0,0,0-.471-.4,1.576,1.576,0,0,0-.683-.142,1.472,1.472,0,0,0-.938.288.9.9,0,0,0-.361.731.946.946,0,0,0,.5.822,2.982,2.982,0,0,0,.7.3,2.052,2.052,0,0,1,.615.264.442.442,0,0,1,.169.374.438.438,0,0,1-.167.356.789.789,0,0,1-.5.135.919.919,0,0,1-.593-.171.6.6,0,0,1-.207-.483Zm-1.233-2.562v3.668h.636v-3.668Zm5.944,3.2a.764.764,0,0,1-.654-.331,1.6,1.6,0,0,1-.235-.935V7157a1.57,1.57,0,0,1,.239-.915.814.814,0,0,1,1.3,0,1.588,1.588,0,0,1,.23.936v.191a1.64,1.64,0,0,1-.226.942A.756.756,0,0,1,3367.613,7158.479Zm4.052-8.714h-3.521v-3.625l3.52,3.624Z",
    transform: "translate(-1922.399 -7129)",
    fill: "#851d62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIso);
export default __webpack_public_path__ + "static/media/ic_iso.31d5938b11361d4bfcc62045bcd094e4.svg";
export { ForwardRef as ReactComponent };